export default function InitView({ text }: { text: string }) {
	return (
		<div className="flex items-center justify-center gap-3 my-8">
			<svg
				width="51"
				height="50"
				viewBox="0 0 51 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M35.9167 5.0625H15.0834C8.83335 5.0625 4.66669 9.22917 4.66669 15.4792V27.9792C4.66669 34.2292 8.83335 38.3958 15.0834 38.3958V42.8333C15.0834 44.5 16.9375 45.5 18.3125 44.5625L27.5834 38.3958H35.9167C42.1667 38.3958 46.3334 34.2292 46.3334 27.9792V15.4792C46.3334 9.22917 42.1667 5.0625 35.9167 5.0625ZM25.5 30.4167C24.625 30.4167 23.9375 29.7083 23.9375 28.8542C23.9375 28 24.625 27.2917 25.5 27.2917C26.375 27.2917 27.0625 28 27.0625 28.8542C27.0625 29.7083 26.375 30.4167 25.5 30.4167ZM28.125 21.7708C27.3125 22.3125 27.0625 22.6667 27.0625 23.25V23.6875C27.0625 24.5417 26.3542 25.25 25.5 25.25C24.6459 25.25 23.9375 24.5417 23.9375 23.6875V23.25C23.9375 20.8333 25.7084 19.6458 26.375 19.1875C27.1459 18.6667 27.3959 18.3125 27.3959 17.7708C27.3959 16.7292 26.5417 15.875 25.5 15.875C24.4584 15.875 23.6042 16.7292 23.6042 17.7708C23.6042 18.625 22.8959 19.3333 22.0417 19.3333C21.1875 19.3333 20.4792 18.625 20.4792 17.7708C20.4792 15 22.7292 12.75 25.5 12.75C28.2709 12.75 30.5209 15 30.5209 17.7708C30.5209 20.1458 28.7709 21.3333 28.125 21.7708Z"
					fill="#868687"
				/>
			</svg>
			<p className="max-w-56 text-sm text-gray-400">{text}</p>
		</div>
	)
}
